import Vue from 'vue'
import Router from 'vue-router'
import DwSurveyTempSave from '../views/dw-survey/dw-data/DwSurveyTempSave'
import DwUserBindPhone from '../views/dw-user/DwUserBindPhone'
import DwUserPwdForm from '../views/dw-user/components/DwUserPwdForm'
import DwAdminSurveyAnswerLogList from '../views/dw-admin/admin-survey/answer-log/DwAdminSurveyAnswerLogList'
const Layout = () => import('@/components/layouts/Layout.vue')
const LoginLayout = () => import('@/components/layouts/LoginLayout.vue')
const NoTopLayout = () => import('@/components/layouts/NoTopLayout.vue')
const DwSurveyList = () => import('@/views/dw-survey/dw-survey-list/DwSurveyList')
const DwSurveyAttr = () => import('@/views/dw-survey/dw-collect/DwSurveyAttr')
const DwAnswerUrl = () => import('@/views/dw-survey/dw-collect/DwAnswerUrl')
const DwSiteComp = () => import('@/views/dw-survey/dw-collect/DwSiteComp')
const DwSiteShare = () => import('@/views/dw-survey/dw-collect/DwSiteShare')
const DwAnswerWeixin = () => import('@/views/dw-survey/dw-collect/DwAnswerWeixin')
const DwSurveyCharts = () => import('@/views/dw-survey/dw-data/DwSurveyCharts')
const DwSurveyAnswer = () => import('@/views/dw-survey/dw-data/DwSurveyAnswer')
const DwSurveyAnswerInfo = () => import('@/views/dw-survey/dw-data/DwSurveyAnswerInfo')
const DwUser = () => import('@/views/dw-user/DwUser')
const DwUserPwd = () => import('@/views/dw-user/DwUserPwd')
const Login = () => import('@/views/Login')
const DwTemplate = () => import('../views/dw-template/DwTemplate')
const DwAdminLayout = () => import('@/components/layouts/dw-admin-layout/DwAdminLayout')
const DwAdminSurveyList = () => import('@/views/dw-admin/admin-survey/survey/DwAdminSurveyList')
const DwAdminSurveyGroupList = () => import('@/views/dw-admin/admin-survey/group/DwAdminSurveyGroupList')
const DwAdminSurveyBackgroundList = () => import('@/views/dw-admin/admin-survey/background/DwAdminSurveyBackgroundList')
const EmptyRouterView = () => import('@/components/layouts/EmptyRouterView')
const DwAdminSurveyTemplaterList = () => import('@/views/dw-admin/admin-resource/survey-templater/DwAdminSurveyTemplaterList')
const DwAdminCascadeList = () => import('@/views/dw-admin/admin-resource/cascade-data/DwAdminCascadeList')
const DwAdminUserList = () => import('@/views/dw-admin/admin-user/user/DwAdminUserList')
const DwAdminDeptList = () => import('@/views/dw-admin/admin-user/dept/DwAdminDeptList')
const DwAdminRoleList = () => import('@/views/dw-admin/admin-system/role/DwAdminRoleList')
const DwAdminPermList = () => import('@/views/dw-admin/admin-system/perm/DwAdminPermList')
const DwAdminLogList = () => import('@/views/dw-admin/admin-system/log/DwAdminLogList')
const DwSurveyBindUser = () => import('../views/dw-survey/dw-collect/dw-bind-user-dept/DwSurveyBindUser')
const DwSurveyFinishSrc = () => import('../views/dw-survey/dw-collect/DwSurveyFinishSrc')
const DwTask = () => import('../views/dw-task/DwTask')
const Home = () => import('../views/Home')
const DwAnalysis = () => import('../views/dw-admin/dw-dashboard/dw-analysis/DwAnalysis')
const DwMonitor = () => import('../views/dw-admin/dw-dashboard/dw-monitor/DwMonitor')
const DwSurveyAnalysis = () => import('../views/dw-survey/dw-data/DwSurveyAnalysis')
const DwSurveyDistrict = () => import('../views/dw-survey/dw-data/DwSurveyDistrict')
const DwSurveyFilters = () => import('../views/dw-survey/dw-data/DwSurveyFilters')
const DwAnswer = () => import('../views/dw-survey/dw-collect/DwAnswer')
const DwSurveyPwds = () => import('../views/dw-survey/dw-collect/dw-pwds/DwSurveyPwds')
const DwSurveyIps = () => import('../views/dw-survey/dw-collect/dw-ips/DwSurveyIps')
const DwAdminAppSecret = () => import('../views/dw-admin/admin-system/app/DwAdminAppSecret')
const Register = () => import('../views/Register')
const DwAutoLogin = () => import('../views/dw-common/DwAutoLogin')

Vue.use(Router)

const dwSurveyCollect = [
  {
    path: 'attr/:id',
    name: 'DwSurveyAttr',
    component: DwSurveyAttr
  },
  {
    path: 'url/:id',
    name: 'DwAnswerUrl',
    component: DwAnswerUrl
  },
  {
    path: 'comp/:id',
    name: 'DwSiteComp',
    component: DwSiteComp
  },
  {
    path: 'share/:id',
    name: 'DwSiteShare',
    component: DwSiteShare
  },
  {
    path: 'weixin/:id',
    name: 'DwAnswerWeixin',
    component: DwAnswerWeixin
  },
  {
    path: 'user-bind/:id',
    name: 'DwSurveyBindUser',
    component: DwSurveyBindUser
  },
  {
    path: 'finish-src/:id',
    name: 'DwSurveyFinishSrc',
    component: DwSurveyFinishSrc
  },
  {
    path: 'pwds/:id',
    name: 'DwSurveyPwds',
    component: DwSurveyPwds
  },
  {
    path: 'ips/:id',
    name: 'DwSurveyIps',
    component: DwSurveyIps
  }
]

const dwSurveyData = [
  {
    path: 'analysis/:id',
    name: 'DwSurveyAnalysis',
    component: DwSurveyAnalysis
  },
  {
    path: 'chart/:id',
    name: 'DwSurveyCharts',
    component: DwSurveyCharts
  },
  {
    path: 'district/:id',
    name: 'DwSurveyDistrict',
    component: DwSurveyDistrict
  },
  {
    path: 'data/:id',
    name: 'DwSurveyAnswer',
    component: DwSurveyAnswer
  },
  {
    path: 'filter/:id',
    name: 'DwSurveyFilters',
    component: DwSurveyFilters
  },
  {
    path: 'temp-save/:id',
    name: 'DwSurveyTempSave',
    component: DwSurveyTempSave
  }
]

const routesAdminChildren = [
  {
    path: '/dw/admin/dashboard',
    icon: 'el-icon-odometer',
    name: '控制台',
    component: EmptyRouterView,
    authority: [
      'SUPER_ADMIN',
      'ENT_ADMIN',
      'HT_PROTEMPLATER_LIST',
      'HT_CASCADEDB_LIST'
    ],
    children: [
      {
        path: '/dw/admin/dashboard/analysis',
        icon: 'el-icon-upload',
        name: '分析平台',
        component: DwAnalysis,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_PROTEMPLATER_LIST']
      },
      {
        path: '/dw/admin/dashboard/monitor',
        icon: 'el-icon-upload',
        name: '监控平台',
        component: DwMonitor,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_CASCADEDB_LIST']
      }
    ]
  },
  {
    path: '/dw/admin/survey',
    icon: 'el-icon-s-order',
    name: '问卷管理',
    component: EmptyRouterView,
    authority: [
      'SUPER_ADMIN',
      'ENT_ADMIN',
      'DEPT_ADMIN',
      'HT_SURVEY_MANAGER_SYS',
      'HT_SURVEY_MANAGER_DEPT',
      'HT_SURVEY_LIST',
      'HT_SURVEY_GROUP_LIST'
    ],
    children: [
      {
        path: '/dw/admin/survey/list',
        icon: 'el-icon-upload',
        name: '问卷管理',
        component: DwAdminSurveyList,
        authority: [
          'SUPER_ADMIN',
          'ENT_ADMIN',
          'DEPT_ADMIN',
          'HT_SURVEY_MANAGER_SYS',
          'HT_SURVEY_MANAGER_DEPT',
          'HT_SURVEY_LIST'
        ]
      },
      {
        path: '/dw/admin/survey/group',
        icon: 'el-icon-upload',
        name: '场景管理',
        component: DwAdminSurveyGroupList,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_SURVEY_GROUP_LIST']
      },
      {
        path: '/dw/admin/survey/background',
        icon: 'el-icon-upload',
        name: '背景管理',
        component: DwAdminSurveyBackgroundList,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_SURVEY_GROUP_LIST']
      },
      {
        path: '/dw/admin/survey/c',
        component: EmptyRouterView,
        children: dwSurveyCollect
      },
      {
        path: '/dw/admin/survey/d',
        component: EmptyRouterView,
        children: dwSurveyData
      },
      {
        path: '/dw/admin/survey/answer-log',
        icon: 'el-icon-upload',
        name: '答卷日志',
        component: DwAdminSurveyAnswerLogList,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_SURVEY_GROUP_LIST']
      }
    ]
  },
  {
    path: '/dw/admin/resource',
    icon: 'el-icon-upload',
    name: '资源管理',
    component: EmptyRouterView,
    authority: [
      'SUPER_ADMIN',
      'ENT_ADMIN',
      'HT_PROTEMPLATER_LIST',
      'HT_CASCADEDB_LIST'
    ],
    children: [
      {
        path: '/dw/admin/resource/survey-templater',
        icon: 'el-icon-upload',
        name: '模板管理',
        component: DwAdminSurveyTemplaterList,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_PROTEMPLATER_LIST']
      },
      {
        path: '/dw/admin/resource/cascade',
        icon: 'el-icon-upload',
        name: '级联数据源',
        component: DwAdminCascadeList,
        authority: ['SUPER_ADMIN', 'ENT_ADMIN', 'HT_CASCADEDB_LIST']
      }
    ]
  },
  {
    path: '/dw/admin/user',
    icon: 'el-icon-user-solid',
    name: '用户管理',
    component: EmptyRouterView,
    authority: [
      'SUPER_ADMIN',
      'HT_USER_MANAGER_SYS',
      'HT_USER_MANAGER_DEPT',
      'HT_DEPT_MANAGER_SYS',
      'HT_DEPT_MANAGER_DEPT',
      'HT_USER_LIST',
      'HT_DEPT_LIST'
    ],
    children: [
      {
        path: '/dw/admin/user/user',
        icon: 'el-icon-upload',
        name: '用户管理',
        component: DwAdminUserList,
        authority: [
          'SUPER_ADMIN',
          'HT_USER_MANAGER_SYS',
          'HT_USER_MANAGER_DEPT',
          'HT_USER_LIST'
        ]
      },
      {
        path: '/dw/admin/user/dept',
        icon: 'el-icon-upload',
        name: '部门管理',
        component: DwAdminDeptList,
        authority: [
          'SUPER_ADMIN',
          'HT_DEPT_MANAGER_SYS',
          'HT_DEPT_MANAGER_DEPT',
          'HT_DEPT_LIST'
        ]
      },
      {
        path: '/dw/admin/user/dept/:id',
        component: DwAdminDeptList
      }
    ]
  },
  {
    path: '/dw/admin/system',
    icon: 'el-icon-s-tools',
    name: '系统管理',
    component: EmptyRouterView,
    authority: ['SUPER_ADMIN', 'HT_ROLE_LIST', 'HT_PERM_LIST', 'HT_SYSTEMLOG_LIST'],
    children: [
      {
        path: '/dw/admin/system/role',
        icon: 'el-icon-upload',
        name: '角色管理',
        component: DwAdminRoleList,
        authority: ['SUPER_ADMIN', 'HT_ROLE_LIST']
      },
      {
        path: '/dw/admin/system/perm',
        icon: 'el-icon-upload',
        name: '权限管理',
        component: DwAdminPermList,
        authority: ['SUPER_ADMIN', 'HT_PERM_LIST']
      },
      {
        path: '/dw/admin/system/app-secret',
        icon: 'el-icon-upload',
        name: '密钥管理',
        component: DwAdminAppSecret,
        authority: ['SUPER_ADMIN', 'HT_APP_LIST']
      },
      {
        path: '/dw/admin/system/log',
        icon: 'el-icon-upload',
        name: '系统日志',
        component: DwAdminLogList,
        authority: ['SUPER_ADMIN', 'HT_SYSTEMLOG_LIST']
      }
    ]
  }
]

const routes = [
  {
    path: '/',
    meta: '首页',
    component: Layout,
    children: [
      {
        path: '/',
        // redirect: '/dw/survey'
        component: Home
      },
      {
        path: '/dw/survey',
        name: 'DwSurveyList',
        component: DwSurveyList
      },
      {
        path: '/dw/survey/c',
        name: 'DwSurveyAttr',
        component: EmptyRouterView,
        children: dwSurveyCollect
      },
      {
        path: '/dw/survey/d',
        name: 'DwSurveyAttr',
        component: EmptyRouterView,
        children: dwSurveyData
      },
      {
        path: '/dw/template',
        name: 'DwTemplate',
        component: DwTemplate
      },
      {
        path: '/dw/user/pwd',
        name: 'DwUserPwd',
        component: DwUserPwd
      },
      {
        path: '/dw/user/phone',
        name: 'DwUserBindPhone',
        component: DwUserBindPhone
      },
      {
        path: '/dw/user',
        name: 'DwUser',
        component: DwUser
      },
      {
        path: '/dw/task',
        name: 'DwTask',
        component: DwTask
      },
      {
        path: '/dw/admin/user',
        name: 'AdminUserList',
        component: DwAdminDeptList
      }
    ]
  },
  {
    path: '/dw/admin',
    name: 'LayoutAdmin',
    component: DwAdminLayout,
    children: routesAdminChildren
  },
  {
    path: '/diaowen/:sid',
    name: 'DwAnswer',
    component: DwAnswer
  },
  {
    path: '/no-top',
    name: 'NoTopLayout',
    component: NoTopLayout,
    children: [
      {
        path: '/no-top/dw-survey/d/data/:id/:answerId',
        name: 'DwSurveyAnswerInfo',
        component: DwSurveyAnswerInfo
      },
      {
        path: '/no-top/dw-auto-login',
        name: 'DwAutoLogin',
        component: DwAutoLogin
      },
      {
        path: '/answer/login',
        name: 'DwAnswerLogin',
        component: Login
      },
      {
        path: '/no-top/user/pwd',
        name: 'DwUserPwdForm',
        component: DwUserPwdForm
      }
    ]
  },
  {
    path: '/login',
    name: 'LoginLayout',
    component: LoginLayout,
    children: [
      {
        path: '/',
        name: 'Login',
        component: Login
      },
      // {
      //   path: '/login/register',
      //   name: 'Register',
      //   component: Register
      // }
    ]
  }
]

const router = new Router({
  routes: routes
})

export {routes, routesAdminChildren}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js